import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LANGS = [
    { code: "en", label: "EN" },
    { code: "es", label: "ES" },
    { code: "fr", label: "FR" },
];

export const LanguageSwitcher = ({ variant = "header" }) => {
    const { i18n } = useTranslation();
    const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);

    const onChange = (code) => {
        i18n.changeLanguage(code);
        try {
            document.documentElement.lang = code;
        } catch (err) {
            console.warn("LanguageSwitcher: failed to set <html lang>", err);
        }
    };

    return (
        <div
            data-testid="language-switcher"
            className={`flex items-center gap-1 text-[10px] tracking-[0.22em] uppercase font-display ${
                variant === "header" ? "text-[#A3A3A3]" : "text-[#A3A3A3]"
            }`}
            aria-label="Language selector"
        >
            <Globe className="h-3.5 w-3.5 mr-1 opacity-60" strokeWidth={1.4} />
            {LANGS.map((l, i) => (
                <React.Fragment key={l.code}>
                    {i > 0 && <span className="text-[#444] mx-1">/</span>}
                    <button
                        type="button"
                        onClick={() => onChange(l.code)}
                        data-testid={`lang-${l.code}`}
                        className={`px-0.5 transition-colors ${
                            current === l.code ? "text-[#F4F4F0]" : "hover:text-[#F4F4F0]"
                        }`}
                        aria-pressed={current === l.code}
                    >
                        {l.label}
                    </button>
                </React.Fragment>
            ))}
        </div>
    );
};

export default LanguageSwitcher;
